import script from "./QRColorPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./QRColorPicker.vue?vue&type=script&setup=true&lang=js"

import "./QRColorPicker.vue?vue&type=style&index=0&id=e9924f20&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9924f20"]])

export default __exports__